import { FC } from "react";
import {
    Box,
    Picture,
    Heading,
    Button,
    Icon,
} from "@smile2impress/components/relaunch";
import { useGoToBooking } from "hooks/useGoToBooking";

import { Questions } from "components/Relaunch/Questions";
import getIcon from "utils/getIcon";
import Link from "components/Link";

import { QuestionsWithImageProps } from "./QuestionsWithImage.types";

export const QuestionsWithImage: FC<QuestionsWithImageProps> = ({
    content,
    headingAs,
}) => {
    const { title, image, questions, cta, ctaTestId } = content;

    const { goToBooking } = useGoToBooking();
    if (!cta.onClick && !cta.link) {
        cta.onClick = goToBooking;
    }

    return (
        <Box>
            <Box
                width="100%"
                h={[8, 8, 10]}
                borderRadius={["xs", "xs", "none"]}
                overflow="hidden"
            >
                <Picture {...image} width="100%" />
            </Box>
            <Box px={[0, 0, 4]} mt={[3, 3, 4]} mb={[2, 2, 0]} as="section">
                <Heading
                    as={headingAs}
                    maxW="800px"
                    textStyle={["title1"]}
                    color="text.base"
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                />
            </Box>
            <Box pt={[2, 2, 3]} pb={2} mt={[2]}>
                <Questions content={{ ...questions, large: true }} />
            </Box>
            <Box px={[0, 0, 4]}>
                <Button
                    as={Link}
                    {...(cta.onClick ? { onClick: cta.onClick } : {})}
                    {...(cta.link ? { href: cta.link } : {})}
                    width="100%"
                    variant={cta.variant}
                    data-testid={ctaTestId}
                >
                    {cta.iconLeft && (
                        <Icon
                            w={1}
                            h={1}
                            as={getIcon(cta.iconLeft)}
                            verticalAlign="baseline"
                            mr="8px"
                            marginBottom="-2px"
                        />
                    )}
                    {cta.text}
                    {cta.iconRight && (
                        <Icon
                            w={1}
                            h={1}
                            as={getIcon(cta.iconRight)}
                            verticalAlign="baseline"
                            ml="8px"
                            marginBottom="-2px"
                        />
                    )}
                </Button>
            </Box>
        </Box>
    );
};
